import { ICustomLookupColumn, ICustomLookupOptions, ICustomSearchScreenDialogStyle } from '../constants';
export const LOOKUP_COLUMNS: ICustomLookupColumn[] = [
    {
        dataField: 'Details.Bin',
        caption: 'Bin',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: true
    },
    {
        dataField: 'Details.Description',
        caption: 'Description',
        allowResizing: true,
        minWidth: 150,
        width: 150,
        fixed: true
    },
    {
        dataField: 'Details.BinType',
        caption: 'Bin type',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: true
    },
    {
        dataField: 'Details.OnHandQuantity',
        caption: 'Qty on hand',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false
    },
];

export const SEARCH_SCREEN_DIALOG_STYLE: ICustomSearchScreenDialogStyle = {
    width: '500px',
    maxWidth: '500px',
    height: 'calc(100% - 400px)',
    maxHeight: 'calc(100% - 400px)',
};

export const productBinMasterLookupConstants: ICustomLookupOptions = {
    columns: LOOKUP_COLUMNS,
    dialogStyle: SEARCH_SCREEN_DIALOG_STYLE,
    hideColumnHeaders: false,
    disableGridColumnLines: false
};
